import {
    SET_HELPERS
} from '../Actions/Helpers/HelpersActionTypes'

const initialState = {
    playSounds: true,
}

const helpersReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case SET_HELPERS:
            return { ...state, ...payload };
        default: {
            return state
        }
    }
}

export default helpersReducer